module.exports = __webpack_public_path__ + "img/amex.a4856a44.png";